import { createSlice } from '@reduxjs/toolkit';
import { fetchAllBirthdays } from '../thunks/birthdayThunks.js';

const initialState = {
    fullList: {},
    loading: false,
    error: '',
};

const birthdaysSlice = createSlice({
    name: 'birthdays',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllBirthdays.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(fetchAllBirthdays.fulfilled, (state, action) => {
                state.fullList = action.payload;
                state.loading = false;
            })
            .addCase(fetchAllBirthdays.rejected, (state, action) => {
                state.error = action.payload || 'Failed to fetch birthdays';
                state.loading = false;
            })
            .addDefaultCase((state) => state);
    },
});

export default birthdaysSlice.reducer;
